import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminLayoutComponent } from './containers/admin-layout/admin-layout';
import { DashboardPageComponent } from './containers/dashboard-page/dashboard-page';
import { AdminAreaRoutingModule } from './admin-area-routing.module';
import { AgGridModule } from 'ag-grid-angular';
import {
  MatButtonModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatOptionModule,
  MatSelectModule,
  MatSidenavModule,
  MatSnackBarModule,
  MatToolbarModule,
} from '@angular/material';
import { RouterModule } from '@angular/router';
import { LoginPageComponent } from './containers/login-page/login-page';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { AuthService } from './services/auth.service';
import { AuthGuard } from './guards/auth.guard';
import { MainPageComponent } from './containers/main-page/main-page';
import { DatabaseViewComponent } from './containers/database-view/database-view.component';
import { MareMekomosComponent } from './containers/mare-mekomos/mare-mekomos.component';
import { HebrewPagerComponent } from './containers/hebrew-pager/hebrew-pager.component';
import { ParentCategoryComponent } from './containers/parent-category/parent-category.component';
import { RecordDetailComponent } from './containers/record-detail/record-detail.component';
import { DataService } from './services/data/data.service';
import { NewEntryService } from './services/new-entry.service';
import { UtilPageComponent } from './containers/util-page/util-page';
import { YesNoDialogComponent } from './components/yes-no-dialog/yes-no-dialog';
import { TrustHtmlPipe } from '@fire/pipes';
import { OkDialogComponent } from './components/ok-dialog/ok-dialog.component';
import { OkDialogService } from './services/ok-dialog.service';
import { SourceDialogComponent } from './containers/source-dialog/source-dialog';
import { MasechtaService } from './services/masechta.service';
import { HebrewService } from './services/hebrew.service';
import { EntryUtilityService } from './services/entry-utility.service';
import { ModalScreenService } from './services/modal-screen.service';
import { SourceService } from './services/source.service';
import { MainMenuPageComponent } from './containers/main-menu-page/main-menu-page';
import { PermissionsPageComponent } from './containers/permissions-page/permissions-page';
import { PrintingPageComponent } from './containers/printing-page/printing-page';
import { AuthSuperAdminGuard } from './guards/auth-super-admin.guard';
import { OutputService } from './services/output.service';
import { PrintingOutputPageComponent } from './containers/printing-output-page/printing-output-page';
import { ExportXmlPageComponent } from './containers/export-xml-page/export-xml-page';
import { ExportDocxPageComponent } from './containers/export-docx-page/export-docx-page';
import { DuplicatesDialogComponent } from './containers/duplicates-dialog/duplicates-dialog.component';


@NgModule({
  imports: [

    // @angular
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    RouterModule,
    FormsModule,

    // routes
    AdminAreaRoutingModule,


    // ag-grid
    // AgGridModule.withComponents([...optional Angular Components to be used in the grid....]),
    AgGridModule.withComponents([]),


    // @angular/material
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatDialogModule,
    MatSelectModule,
    MatOptionModule,
    MatFormFieldModule,
    MatInputModule,

  ],
  declarations: [
    AdminLayoutComponent,
    DashboardPageComponent,
    LoginPageComponent,
    MainPageComponent,
    DatabaseViewComponent,
    MareMekomosComponent,
    HebrewPagerComponent,
    ParentCategoryComponent,
    RecordDetailComponent,
    UtilPageComponent,
    YesNoDialogComponent,
    OkDialogComponent,
    TrustHtmlPipe,
    SourceDialogComponent,
    MainMenuPageComponent,
    PermissionsPageComponent,
    PrintingPageComponent,
    ExportXmlPageComponent,
    ExportDocxPageComponent,
    PrintingOutputPageComponent,
    DuplicatesDialogComponent,
  ],
  providers: [
    AuthGuard,
    AuthSuperAdminGuard,
    AuthService,
    DataService,
    NewEntryService,
    OkDialogService,
    MasechtaService,
    HebrewService,
    EntryUtilityService,
    ModalScreenService,
    SourceService,
    OutputService,
  ],
  entryComponents: [
    YesNoDialogComponent,
    OkDialogComponent,
    SourceDialogComponent,
    DuplicatesDialogComponent,
  ]
})

export class AdminAreaModule {}




// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/admin-area.module.ts